import { parseDegrees } from './degrees';
import { parseMgrs, parseUtmText } from './mgrs';
import { parseFullPlusCode } from './plusCode';
import type { ParsedCoordinates } from './types';
import { utmToLatLng } from './utm';

/** Coordinates in any supported format (all parsed locally, synchronously), or null. */
export function parseCoordinates(text: string): ParsedCoordinates | null {
  const compact = text.toUpperCase().replace(/\s+/g, '');

  const mgrs = parseMgrs(compact);
  if (mgrs) return mgrs;

  const utm = parseUtmText(text);
  if (utm) return { ...utmToLatLng(utm.zone, utm.south, utm.easting, utm.northing), format: 'utm' };

  return parseFullPlusCode(compact) ?? parseDegrees(text);
}
